import { isNonNullable } from './isNonNullable'

export const queryParse = (query: string | undefined) => {
	if (!query || query === '?') {
		return undefined
	}
	return query.startsWith('?') ? parseInternal(query.substring(1)) : parseInternal(query)
}

const parseInternal = (query: string) =>
	query
		// Break query string into key/value argument segments.
		.split(/&/g)
		// Decode each segment and split only at the first "=" boundary.
		.map((arg) => {
			const boundaryIndex = arg.indexOf('=')

			if (boundaryIndex === -1) {
				return [decodeURIComponent(arg), undefined] as const
			}

			return [
				decodeURIComponent(arg.substring(0, boundaryIndex)),
				decodeURIComponent(arg.substring(boundaryIndex + 1)),
			] as const
		})
		.reduce(
			(result, [key, value]) => {
				if (key.endsWith('[]') && value !== undefined) {
					const arrayKey = key.substring(0, key.length - 2)
					const array = Array.isArray(result[arrayKey]) ? (result[arrayKey] as Array<string>) : []
					result[arrayKey] = array
					array.push(value)
				} else if (value === undefined) {
					result[key] = true
				} else if (value === 'false') {
					result[key] = false
				} else {
					result[key] = value
				}
				return result
			},
			{} as Record<string, string | boolean | Array<string>>,
		)

export const querySerialize = (
	values: Record<string, string | number | boolean | Array<string> | Array<number> | null | undefined>,
	prefix?: string,
) => {
	const query = Object.entries(values)
		.filter((entry): entry is [string, string | number | true] => entry[1] !== undefined && entry[1] !== null)
		.map(([key, value]) => {
			if (Array.isArray(value)) {
				if (value.length === 0) return undefined
				return value.map((entry) => `${encodeURIComponent(`${key}[]`)}=${encodeURIComponent(entry)}`).join('&')
			}
			if (typeof value === 'boolean') {
				if (value) return encodeURIComponent(key)
				return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
			}
			return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
		})
		.filter(isNonNullable)
		.join('&')

	return query && prefix ? prefix + query : query
}

export const queryAppend = (
	path: string,
	values: Record<string, string | number | boolean | Array<string> | Array<number> | null | undefined> | undefined,
) => {
	if (!values) return path

	return path + querySerialize(values, path.includes('?') ? '&' : '?')
}
